import React from "react";
import { videoElement } from "./video";

class VideoTimer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { time: 0 };
    this.setTime = this.setTime.bind(this);
  }

  setTime() {
    this.setState({ time: videoElement.currentTime });
  }

  componentDidMount() {
    videoElement.addEventListener("timeupdate", this.setTime);
  }

  render() {
    return <p>{this.state.time}</p>;
  }
}

export { VideoTimer };
